export default "__VITE_ASSET__95aacc3f__"